import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import ReactGA from 'react-ga';

import { AppRoutes } from './AppRoutes';

import configureStore from './store/configureStore';
import * as settings from './settings';

import styles from './styles/index.scss';

const store = configureStore();

// Initialize Google Analytics tracking
ReactGA.initialize('UA-350786-8', {
  debug: !settings.IS_PROD,
  gaOptions: {
    dimension2: true,
    anonymizeIp: true,
  },
});

// Initialize Helpscout Beacon
// if (HS.beacon.destroy) HS.beacon.destroy();
// HS.beacon.config({
//   color: '#46CCC5',
//   icon: 'question',
//   modal: true,
//   poweredBy: false,
//   topics: [
//     { val: 'newdesign', label: 'New Design' },
//     { val: 'bug', label: 'Something is broken' },
//     { val: 'question', label: 'Question' },
//     { val: 'suggestion', label: 'Idea' },
//     { val: 'bizdev', label: 'Business Inquiry' },
//   ],
//   attachment: false,
//   autoInit: false,
//   instructions:
//     'Thanks for taking the time to write in. We read every message that we receive!',
// });
// if (HS.beacon.init) HS.beacon.init();

// Initialize Sentry.io client error capture
// if (typeof Raven !== 'undefined')
//   Raven.config('https://1994080b047d407a843c23c1b89d118c@sentry.io/159141', {
//     environment: process.env.NODE_ENV || 'development',
//     whitelistUrls: [/funbrain/],
//     ignoreErrors: [
//       'a.o.postMessage', // Ad related
//       'this.U', // Ad related
//       'gpt', // Ad related
//       'y9d', // Ad related
//       'adManager',
//       'googletag',
//       'googlesyndication',
//       'originplatform',
//       'w.dcsx.engn',
//       'Unexpected token',
//       'event is not defined',
//       'Script error.',
//       'sizeMapping',
//       'getHostNode',
//       'getAttributeKeys',
//       'defineSizeMapping',
//     ],
//     // shouldSendCallback: (data) => {
//     //   console.log(data);
//     //   return true;
//     // },
//     autoBreadcrumbs: process.env.NODE_ENV === 'production',
//     sampleRate: 0.1,
//   }).install();

// The function used to log pages as people move through the site.
// const logPageView = () => {
//   ReactGA.set({ page: location.pathname });
//   ReactGA.pageview(location.pathname);
// };


ReactDOM.render(
  <Provider store={store}>
    <AppRoutes />
  </Provider>,
  document.getElementById('app')
);
